import clsx from "clsx";

import { MobileCard, VerticalCenter } from "components/shared/mobile_components";

const STAGE_OVERLAY_CONTENT = {
  instructorHybridWaitingToStart: [
    "Welcome to Class!",
    "You can launch the presentation view from the controls at the top of the classroom.",
  ],
  instructorVirtualWaitingToStart: [
    "Welcome to Class!",
    "You can start the class by selecting a step from the timeline on the right.",
  ],
  studentWaitingToStart: ["Welcome to Class!", "Your instructor will start class shortly."],
  presentationWaitingToStart: ["Welcome to Class!", "Your instructor will start class shortly."],
  studentHybridMobileEmptyStage: [
    "Class In Progress",
    "Return here when it's time for a poll or breakout.",
  ],
  instructorEmptyStage: ["", ""],
  studentEmptyStage: ["", ""],
  presentationEmptyStage: ["", ""],
};

function StageOverlay({
  isWaitingToStart,
  isInstructor,
  isInPerson,
  noContentToDisplay,
  isPresentationView,
  isMobile,
}: {
  isWaitingToStart: boolean;
  isInstructor: boolean;
  isInPerson: boolean;
  noContentToDisplay: boolean;
  isPresentationView: boolean;
  isMobile: boolean;
}) {
  if (!isWaitingToStart && !noContentToDisplay) {
    return null;
  }
  let stageOverlayContent = ["Class in Progress", ""];
  if (isWaitingToStart && isPresentationView) {
    stageOverlayContent = STAGE_OVERLAY_CONTENT.presentationWaitingToStart;
  } else if (noContentToDisplay && isPresentationView) {
    stageOverlayContent = STAGE_OVERLAY_CONTENT.presentationEmptyStage;
  } else if (isWaitingToStart && isInstructor && isInPerson) {
    stageOverlayContent = STAGE_OVERLAY_CONTENT.instructorHybridWaitingToStart;
  } else if (isWaitingToStart && isInstructor && !isInPerson) {
    stageOverlayContent = STAGE_OVERLAY_CONTENT.instructorVirtualWaitingToStart;
  } else if (noContentToDisplay && isInstructor) {
    stageOverlayContent = STAGE_OVERLAY_CONTENT.instructorEmptyStage;
  } else if (isWaitingToStart && !isInstructor) {
    stageOverlayContent = STAGE_OVERLAY_CONTENT.studentWaitingToStart;
  } else if (noContentToDisplay && !isInstructor && isInPerson && isMobile) {
    stageOverlayContent = STAGE_OVERLAY_CONTENT.studentHybridMobileEmptyStage;
  } else if (noContentToDisplay && !isInstructor) {
    stageOverlayContent = STAGE_OVERLAY_CONTENT.studentEmptyStage;
  } else {
    window.flightLogger.error(
      `Unexpected stage state: empty=${noContentToDisplay}, started=${!isWaitingToStart}, instructor=${isInstructor}, inPerson=${isInPerson}`,
    );
  }

  if (isMobile) {
    return (
      <VerticalCenter>
        <MobileCard>
          <div>
            <h4 className="h4 bold mb4 center">{stageOverlayContent[0]}</h4>
            <div className="text-black-tint-40">{stageOverlayContent[1]}</div>
          </div>
        </MobileCard>
      </VerticalCenter>
    );
  }

  return (
    <VerticalCenter
      className="bg-black-tint-10 absolute"
      style={{
        pointerEvents: "none",
      }}
    >
      <div
        className={clsx({
          "presentation-view": isPresentationView,
        })}
        style={{
          overflowY: "unset",
        }}
      >
        <h1 className="h1 bold mb4 text-white center" data-testid="stage-overlay-line-1">
          {stageOverlayContent[0]}
        </h1>
        <div className="text-white body-l" data-testid="stage-overlay-line-2">
          {stageOverlayContent[1]}
        </div>
      </div>
    </VerticalCenter>
  );
}

export { StageOverlay };
